module.exports = __webpack_public_path__ + "img/pagina-nao-encontrada.48c92a39.png";